import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ArrowsClockwise } from "@phosphor-icons/react";
import { ConnectionCheck } from "@/components/votel/ConnectionCheck";
import { ProductMap } from "@/components/votel/ProductMap";
import { UnattributedCharges } from "@/components/votel/UnattributedCharges";
import { SaleAlertToggle } from "@/components/votel/SaleAlertToggle";
import { FirstCreditedSale } from "@/components/votel/FirstCreditedSale";

export default function VotelSync() {
  const [map, setMap] = useState([]);
  const [reps, setReps] = useState([]);
  const [charges, setCharges] = useState([]);
  const [syncing, setSyncing] = useState(false);

  const load = () => {
    api.get("/admin/votel/product-map").then((r) => setMap(r.data));
    api.get("/admin/votel/charges").then((r) => setCharges(r.data));
  };
  useEffect(() => {
    load();
    api.get("/reps").then((r) => setReps(r.data.filter((x) => !x.is_demo)));
  }, []);

  const sync = async () => {
    setSyncing(true);
    try {
      const r = await api.post("/admin/votel/sync");
      r.data.status === "ok"
        ? toast.success(`Synced ${r.data.seen} charges · ${r.data.new_deals} new deal(s) · ${r.data.renewals} renewal(s) · ${r.data.unattributed} unattributed`)
        : toast.error("Votel not reachable from here — nothing changed");
      load();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setSyncing(false); }
  };

  return (
    <div>
      <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="font-heading text-3xl font-black tracking-tight">Votel Sales</h1>
          <p className="mt-1 text-sm text-muted-foreground">Rep attribution by Votel product from the transactions feed · read-only · auto-sync every 15 min</p>
        </div>
        <Button onClick={sync} disabled={syncing} className="gap-2" data-testid="votel-sync-btn">
          <ArrowsClockwise size={16} weight="bold" className={syncing ? "animate-spin" : ""} />
          {syncing ? "Syncing…" : "Sync now"}
        </Button>
      </div>
      <div className="space-y-6">
        <ConnectionCheck />
        <FirstCreditedSale />
        <SaleAlertToggle />
        <ProductMap rows={map} reps={reps} onChange={load} />
        <UnattributedCharges charges={charges} reps={reps} onChange={load} />
      </div>
    </div>
  );
}
